import { GlButton, GlSkeletonLoader, GlSearchBoxByType, GlCollapse } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import axios from '../../lib/utils/axios_utils.js?vue3';
import { sidebarEntriesToTree } from '../utils';
import WikiSidebarEntry from './wiki_sidebar_entry.vue?vue3';
export default {
    name: 'WikiSidebarEntries',
    components: {
        WikiSidebarEntry,
        GlButton,
        GlSkeletonLoader,
        GlSearchBoxByType,
        GlCollapse
    },
    inject: [
        'sidebarPagesApi',
        'hasCustomSidebar',
        'viewAllPagesPath',
        'editing',
        'customSidebarContent'
    ],
    props: {
        pagesListExpanded: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    data () {
        return {
            allEntries: [],
            entries: [],
            totalCount: 0,
            isLoadingContent: false,
            searchTerm: ''
        };
    },
    watch: {
        async searchTerm () {
            this.entries = sidebarEntriesToTree(this.allEntries.filter((entry)=>entry.title.toLowerCase().includes(this.searchTerm.toLowerCase())));
        }
    },
    async mounted () {
        this.isLoadingContent = true;
        let { data: entries } = await axios.get(this.sidebarPagesApi);
        this.isLoadingContent = false;
        entries = entries.filter((entry)=>entry.slug !== '_sidebar');
        this.entries = sidebarEntriesToTree(entries);
        this.totalCount = entries.length;
        this.allEntries = entries;
    }
};
